import { Shell } from '../components/Shell';
import { Link } from '../lib/router';

export function NotFound() {
  return (
    <Shell title="Page not found">
      <Link to="/" className="text-accent">
        Back to today’s round
      </Link>
    </Shell>
  );
}
